var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dictionaryVar as dict2 } from "../frameworkDictionaryOverwrite/framework3_dictionary";
import { dictionaryVar as dict1 } from "../settings/Dictionary_AngryBirds";
var fullDictionary = __assign({}, dict2);
for (var key in dict1) {
    fullDictionary[key] = __assign(__assign({}, dict2[key]), dict1[key]);
}
var tgfDictionary = /** @class */ (function () {
    function tgfDictionary() {
    }
    tgfDictionary.getText = function (key) {
        return this._dictionary[key];
    };
    tgfDictionary.setLanguage = function (language) {
        this._dictionary = this._dictionariesByLanguage[language];
        this._language = language;
    };
    tgfDictionary.getLanguage = function () {
        return this._language;
    };
    tgfDictionary.getAvailableLanguages = function () {
        return Object.keys(this._dictionariesByLanguage);
    };
    tgfDictionary._dictionariesByLanguage = fullDictionary;
    tgfDictionary._dictionary = null;
    tgfDictionary._language = null;
    return tgfDictionary;
}());
export { tgfDictionary };
